module.exports = __webpack_public_path__ + "media/images/icons/invoices-e2723b1f4adb92be3bbf103564eff016.svg";